import { useFirebase } from '@packages/web-shared';
import { FirebaseStorage, getDownloadURL, ref } from 'firebase/storage';
import { useState } from 'react';

const downloadFirestoreDocument = (
  firebaseStorage: FirebaseStorage,
  firebaseStoragePath: string,
  fileName: string,
) => {
  return new Promise((resolve, reject) => {
    getDownloadURL(ref(firebaseStorage, firebaseStoragePath))
      .then((url) => {
        // This can be downloaded directly:
        const xhr = new XMLHttpRequest();
        xhr.responseType = 'blob';
        xhr.onload = () => {
          const blob = xhr.response;
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.target = '_blank';
          link.download = fileName;
          link.click();
          resolve(true);
        };
        xhr.open('GET', url);
        xhr.send();
      })
      .catch(reject);
  });
};

export const useDownloadDocument = () => {
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const { storage } = useFirebase();

  const download = async (firebaseStoragePath: string, fileName: string) => {
    try {
      setLoading(true);
      setErrorMessage(null);

      await downloadFirestoreDocument(storage, firebaseStoragePath, fileName);
    } catch (err) {
      const errorMsg = `Cannot download the file ${firebaseStoragePath ?? ''}`;
      console.error(errorMsg);
      console.error(err);
      setErrorMessage(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  return { download, loading, errorMessage };
};
